import { Controller } from "@hotwired/stimulus";

// The Assign QTAG modal's submit button names the tag it will link
// (TASK-274.2): "Link QTAG" until a spare tag is ticked, then "Link A000516".
//
// Put on the modal's .form-container with a `button` target. Both events bubble
// up from the choices frame, which frame-filter swaps as the member types:
//   data-action="change->link-qtag-button#sync turbo:frame-load->link-qtag-button#sync"
// Each radio carries data-qtag-reference; a pre-selected exact match is read on
// the frame load.
export default class extends Controller {
  static targets = ["button"];

  connect() {
    this.sync();
  }

  sync() {
    if (!this.hasButtonTarget) return;
    const chosen = this.element.querySelector('input[name="qtag_id"]:checked');
    const reference = chosen && chosen.dataset.qtagReference;
    this.buttonTarget.textContent = reference ? `Link ${reference}` : "Link QTAG";
  }
}
